export const CaretDownIcon = ({ className }: { className?: string }) => (
  <svg
    fill="currentColor"
    className={`w-4 h-4  ${className}`}
    role="presentation"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 10"
  >
    <path d="M8.00492 9.355C7.74492 9.355 7.49492 9.255 7.29492 9.065L0.294922 2.055L1.70492 0.645004L7.99492 6.935L14.2949 0.645004L15.7049 2.055L8.70492 9.055C8.50492 9.255 8.25492 9.345 7.99492 9.345L8.00492 9.355Z" />
  </svg>
);

export const CaretUpIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    className="w-4 h-4"
  >
    <path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z" />
  </svg>
);

export const SearchIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    className="w-4 h-4"
  >
    <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
  </svg>
);

export const CheckmarkIcon = () => (
  <svg
    className="w-5 h-5 ml-2 inline-block"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M5 13l4 4L19 7"
    />
  </svg>
);

export const AlertIcon = () => (
  <svg
    role="presentation"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    fill="currentColor"
    className="w-4 h-4 text-red-600"
  >
    <path d="M8.99788 9.985H6.99788V5.985H8.99788V9.985ZM8.99788 10.985H6.99788V12.985H8.99788V10.985ZM15.8479 15.515C16.0279 15.225 16.0479 14.855 15.8879 14.545L8.88788 0.535C8.54788 -0.145 7.43788 -0.145 7.09788 0.535L0.107879 14.535C-0.0421213 14.845 -0.0321213 15.215 0.147879 15.505C0.327879 15.795 0.647879 15.975 0.997879 15.975H14.9979C15.3479 15.975 15.6679 15.795 15.8479 15.505V15.515ZM7.99788 3.215L13.3779 13.975H2.61788L7.99788 3.215Z"></path>
  </svg>
);

export const UploadIcon = () => (
  <svg
    width="20"
    height="22"
    viewBox="0 0 20 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="upload">
      <path
        id="Vector"
        d="M0 2H20"
        stroke="#161D26"
        strokeWidth="2.85714"
        stroke-linejoin="round"
      ></path>
      <path
        id="Vector_2"
        d="M16.4287 14.1429L10.0001 7.71436L3.57153 14.1429"
        stroke="#161D26"
        strokeWidth="2.85714"
        stroke-linejoin="round"
      ></path>
      <path
        id="Vector_3"
        d="M10 9.14258V21.9997"
        stroke="#161D26"
        strokeWidth="2.85714"
        stroke-linejoin="round"
      ></path>
    </g>
  </svg>
);

export const SpinnerIcon = (): JSX.Element => (
  <svg
    className="animate-spin h-8 w-8 text-gray-900"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-label="Loading spinner"
    role="img"
  >
    <circle
      className="opacity-25"
      cx="12"
      cy="12"
      r="10"
      stroke="currentColor"
      strokeWidth="4"
    ></circle>
    <path
      className="opacity-75"
      fill="currentColor"
      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
    ></path>
  </svg>
);

export const ArrowRightIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    className="w-4 h-4 transition-transform duration-300 ease-in-out transform group-hover:translate-x-1"
  >
    <path
      d="M1 7.00001H11.91L8.32 3.74001L9.67 2.26001L15.17 7.26001C15.38 7.45001 15.5 7.72001 15.5 8.00001C15.5 8.28001 15.38 8.55001 15.17 8.74001L9.67 13.74L8.32 12.26L11.91 9.00001H1V7.00001Z"
      fill="currentColor"
    />
  </svg>
);

export const ArrowLeftIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    className="w-4 h-4 transition-transform duration-300 ease-in-out transform group-hover:translate-x-1"
  >
    <path
      d="M0.83 7.26001L6.33 2.26001L7.68 3.74002L4.09 7.00002H15V9.00002H4.09L7.68 12.26L6.33 13.74L0.83 8.74002C0.62 8.55002 0.5 8.28002 0.5 8.00002C0.5 7.72002 0.62 7.45001 0.83 7.26001Z"
      fill="currentColor"
    />
  </svg>
);

export const ArrowRightLargeIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="transform group-hover:translate-x-1 transition-transform duration-300"
  >
    <path
      d="M16.172 11L10.808 5.636L12.222 4.222L20 12L12.222 19.778L10.808 18.364L16.172 13H4V11H16.172Z"
      fill="black"
    />
  </svg>
);

export const InfoIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M9 8H11V15H9V8ZM9 7H11V5H9V7ZM20 10C20 15.51 15.51 20 10 20C4.49 20 0 15.51 0 10C0 4.49 4.49 0 10 0C15.51 0 20 4.49 20 10ZM18 10C18 5.59 14.41 2 10 2C5.59 2 2 5.59 2 10C2 14.41 5.59 18 10 18C14.41 18 18 14.41 18 10Z"
      fill="#006CE0"
    />
  </svg>
);

export const CaretRight = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="8"
    height="14"
    viewBox="0 0 8 14"
    fill="none"
  >
    <path
      d="M0 11.99L5.29 6.70001L0 1.41003L1.41 0L7.41 6C7.8 6.39 7.8 7.02003 7.41 7.41003L1.41 13.41L0 12V11.99Z"
      fill="white"
    />
  </svg>
);

export const CaretDownIconSmall = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M8.00004 11C7.74004 11 7.49004 10.9 7.29004 10.71L3.79004 7.21005L5.20004 5.80005L7.99004 8.59005L10.78 5.80005L12.19 7.21005L8.69004 10.71C8.49004 10.91 8.24004 11 7.98004 11H8.00004Z"
      fill="#161D26"
    />
  </svg>
);
